import { useEffect, type JSX } from "react";

import CONFIG from "@/config";

import { buildUrl } from "@utils/url";
import tokenManager from "@/utils/tokenManager";
import { isAuth0Enabled } from "@/auth/authConfig";

// Legacy path: unchanged.
const LegacyProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const token = tokenManager.getToken();

  useEffect(() => {
    if (!token) {
      const params = {
        domain: encodeURIComponent(window.location.origin),
        completeUrl: CONFIG.endPoints.auth0 + "/",
        failUrl: CONFIG.endPoints.auth0 + "/register/fail",
        serverLogin: "true",
      };
      const loginURL = buildUrl(
        CONFIG.endPoints.userService,
        "/auth/login",
        params
      );
      window.location.href = loginURL;
    }
  }, [token]);

  if (token) {
    return children;
  }

  // Render null or a loading spinner while the redirect happens
  return null;
};

// Auth0 path: the top-level <Auth> gate has already guaranteed an authenticated
// session by the time any route renders, so this is a passthrough. The login
// redirect lives in one place (<Auth>), not duplicated per route.
const ProtectedRoute = ({ children }: { children: JSX.Element }) =>
  isAuth0Enabled() ? children : <LegacyProtectedRoute>{children}</LegacyProtectedRoute>;

export default ProtectedRoute;
